import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SELECT_GROUP_CONRAINER: `${cleanedFilename(
    __filename,
  )}-select-group-container`,
};
